import React from 'react'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { TitleMD } from '@/atoms/Text'
import { HorizontalItemScroller } from '@/molecules/HorizontalItemScroller'
import { Note } from '@/services/StoriesService'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { CommunityVideoCard } from './CommunityVideoCard'

interface CommunityVideosListProps {
  communityStories?: Note[]
}

export const CommunityVideosList: React.FC<CommunityVideosListProps> = ({ communityStories }) => {
  const { t } = useTranslate('watch')

  return (
    <div className="h-full w-full">
      {communityStories?.length ? (
        <>
          <div className="my-6 flex flex-row flex-wrap items-center">
            <PaddedContainer fluid>
              <TitleMD aria-label="community-tab-header" weight="bold" className="md:photon-title-md mr-auto">
                <Translate t={t} i18nKey="community">
                  Community
                </Translate>
              </TitleMD>
            </PaddedContainer>
          </div>
          <div className="w-full">
            <HorizontalItemScroller
              arrows
              responsive={[
                {
                  breakpoint: 1800,
                  settings: {
                    slidesToScroll: 5,
                    slidesToShow: 5,
                  },
                },
                {
                  breakpoint: 1536,
                  settings: {
                    slidesToScroll: 3.5,
                    slidesToShow: 3.5,
                  },
                },
                {
                  breakpoint: 1280,
                  settings: {
                    slidesToScroll: 3,
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToScroll: 2.5,
                    slidesToShow: 2.5,
                  },
                },
                {
                  breakpoint: 640,
                  settings: {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToScroll: 1.5,
                    slidesToShow: 1.5,
                  },
                },
              ]}
              wrapperClassName="w-full px-4 sm:px-8 md:px-12 xl:px-16"
              scrollerClassName="w-full"
              centerPadding="0px"
            >
              {communityStories?.map((story) => (
                <CommunityVideoCard key={story.id} story={story} className="pr-2" />
              ))}
            </HorizontalItemScroller>
          </div>
        </>
      ) : null}
    </div>
  )
}
